import { Stack, Typography, SelectChangeEvent } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import FilterDatePicker from 'src/components/filter-form/filter-date-picker';
import FilterSingleSelect from 'src/components/filter-form/filter-single-select';
import { PositionFilters, PositionFilterKey, PositionFilterValue } from 'src/type/position';
import UserSearchAutocomplete, { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import { PositionTypeOptions } from '../position/utils';

type Props = {
  filters: PositionFilters;
  onFilters: (name: PositionFilterKey, value: PositionFilterValue) => void;
  dateError: boolean;
  disabledSearch?: boolean;
  disabledDate?: boolean;
};

export default function ExpiringTxTableToolbar({
  filters,
  onFilters,
  dateError,
  disabledSearch,
  disabledDate,
}: Props) {
  const handleFilterName = useCallback(
    (user: UserOption | null) => {
      onFilters('name', user);
    },
    [onFilters]
  );

  const handleFilterType = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('type', event.target.value);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('startDate', newValue);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue: Dayjs | null) => {
      onFilters('endDate', newValue);
    },
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        pr: { xs: 2.5, md: 1 },
        width: 1,
      }}
    >
      <FilterSingleSelect
        label="ประเภท"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.type}
        onChange={handleFilterType}
        options={PositionTypeOptions}
      />

      {!disabledDate && (
        <>
          <FilterDatePicker
            label="จากวันที่"
            value={filters.startDate}
            onChange={handleFilterStartDate}
          />
          <FilterDatePicker
            label="ถึงวันที่"
            value={filters.endDate}
            onChange={handleFilterEndDate}
            dateError={dateError}
          />
        </>
      )}

      <Typography variant="subtitle1">
        ข้อมูล ณ วันที่ {dayjs().format('DD MMMM BBBB เวลา HH:mm น')}
      </Typography>

      {!disabledSearch && (
        <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
          <UserSearchAutocomplete value={filters.name} onChange={handleFilterName} />
        </Stack>
      )}
    </Stack>
  );
}
